/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import { navigate } from 'gatsby';
/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/
// Utils
import urlHelper from './url';


const onItemClick = (item) => { navigate(urlHelper.getHelpArticle(item.slug)); };
const onSelectItem = item => (urlHelper.getHelpArticle(item.slug));
const onSubmit = (query) => {
  const url = urlHelper.getHelpSearch(query);
  window.location.assign(url);
};


/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default {
  onItemClick,
  onSelectItem,
  onSubmit,
};
